<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline mr-4">
            <v-icon class="pr-2">person_add</v-icon>
            Invite a New User
          </span>
          <v-btn absolute right depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="invite_user" data-vv-scope="invite_user" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="email"
                  name="email"
                  label="Enter email*"
                  type="email"
                  v-validate="'required|email'"
                  data-vv-name="invite_user.email"
                  :error-messages="errors.collect('invite_user.email')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="inviteUser()" :loading="loading" :disabled="loading">Invite</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'InviteUserModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['inviteUserDialog', 'loading'],
  data () {
    return {
      dialog: this.inviteUserDialog,
      email: '',
      dictionary: {
        en: {
          custom: {
            'invite_user.email': {
              required: 'Please type email',
              email: 'E-mail not valid'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    inviteUserDialog: {
      handler () {
        this.dialog = this.inviteUserDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('inviteUserDialog', this.dialog)
      }
    }
  },
  methods: {
    inviteUser () {
      this.$validator.validateAll('invite_user').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)
          this.$store.dispatch('INVITE_USER', this.email).then(res => {
            this.$toasted.show('Invite letter was sent')
            this.$parent.$emit('loading', false)
            this.closeModal()
          }, err => {
            console.log('INVITE_USER error', err)
            this.$parent.$emit('loading', false)
            let errorText = this.$services.getApiError(err)
            if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
          })
        }
      })
    },
    closeModal () {
      this.dialog = false
      this.email = ''
      // setTimeout(() => {
      //   this.$validator.errors.clear('invite_user')
      // }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/InviteUserModal.vue